import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { authToken } from 'config/axios';
import { catchAsync } from 'helpers';

export const resetPassword = createAsyncThunk(
  'auth/resetPassword',
  catchAsync(async ({ token, credentials }, thunkAPI) => {
    const res = await axios.post(`/auth/reset/${token}`, credentials);
    authToken.set(res.data.token);
    return res.data;
  })
);
